import { useState } from 'react'
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay'
import { Loading } from 'src/components'
import { Icon } from 'src/components'
import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'
import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { PublicationEndpoints } from 'src/client/publication/constants'
import { NoImage } from 'src/components/noImage'
import { useUser } from 'src/hook/useUser'
import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { Wrapper as LoaderWrapper } from '../postImage/postImage.styles'
import { PostVideoProps } from './postVideo.types'
import { REQUEST_CONFIG } from './postVideo.constants'
import { PlayWrapper, Wrapper } from './postVideo.styles'

const PostVideo = ({ post, aspectRatio, isEdit = false }: PostVideoProps) => {
  const [emptyImage, setEmptyImage] = useState(false)
  const { authStatus } = useUser()

  const isUnauthenticated = authStatus === AuthStatus.UNAUTHENTICATED
  const url = isUnauthenticated
    ? PublicationEndpoints.getPublicPostImage(post.id)
    : PublicationEndpoints.getPostImage(post.id)

  const { data, isError, isLoading } = useHotRequest<{ data: string }>(url, {
    cacheKey: [url],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_SPARKLE,
    params: {
      redirect: false,
      ...(post?.mediaWidth &&
        post?.mediaHeight && {
          dimensions: `${post.mediaWidth}x${post.mediaHeight}`
        })
    },
    queryOptions: {
      ...REQUEST_CONFIG
    }
  })

  const src = data?.data

  if (isLoading) {
    return (
      <LoaderWrapper data-test="post-video">
        <Loading full />
      </LoaderWrapper>
    )
  }

  if (isError) {
    return null
  }

  const handleError = () => {
    setEmptyImage(true)
  }

  return (
    <Wrapper
      data-test="post-video"
      className="_bg-gray-100"
      $isEdit={isEdit}
      $aspectRatio={aspectRatio}
    >
      <PlayWrapper className="_d-flex _align-items-center _justify-content-center _bg-gray-100 _position-absolute _rounded-lg">
        <Icon icon={faPlay} className="_text-gray-900" size="lg" />
      </PlayWrapper>

      {emptyImage ? (
        <NoImage className="_w-full _h-full" />
      ) : (
        <img src={src} alt={post.title} loading="lazy" onError={handleError} />
      )}
    </Wrapper>
  )
}

export default PostVideo
